import { formatDob } from "../../Helpers/Utils";
import React from "react";
import { DetailCard } from "../../Helpers/Components/Needed";
import { FaIdCardAlt } from "react-icons/fa";
import { LiaCarSideSolid } from "react-icons/lia";
import { MdOutlineDirectionsBike } from "react-icons/md";

const DL = (data) => {
    return (
        <React.Fragment>
            <DetailCard title="Driving License Details" icon={<FaIdCardAlt />}>
                <div className="aadhaar-hero mb-4 p-4">
                    <div className="row align-items-center">
                        {data?.rejected?.detail?.profile_image && (
                            <div className="col-md-3 text-center mb-3 mb-md-0">
                                <img src={`data:image/jpeg;base64,${data?.rejected?.detail?.profile_image}`} className="aadhaar-photo" alt="Driving Licence" />
                            </div>
                        )}
                        <div className="col-md-9" >
                            <div className="d-flex justify-content-between align-items-start flex-wrap">
                                <div>
                                    <h6 className="text-uppercase text-light opacity-75">
                                        Driving License
                                    </h6>
                                    <h2 className="fw-bold text-white">{data?.rejected?.detail?.name}</h2>
                                    <p className="text-light mb-1">
                                        S/o {data?.rejected?.detail?.father_or_husband_name}
                                    </p>

                                    <div className="mt-3">
                                        <span className="dl-number-badge">
                                            {data?.rejected?.detail?.license_number}
                                        </span>
                                    </div>
                                    <div className="d-flex gap-4 mt-3 text-light small">
                                        <span><strong>DOB:</strong> {formatDob(data?.rejected?.detail?.dob)}</span>
                                        <span><strong>Issued:</strong> {data?.rejected?.detail?.doi}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-4">
                    <h4 className="section-title mb-4">Personal Information</h4>
                    <div className="info-grid px-3" >
                        <div className="info-field">
                            <div className="info-field-label"> Full Name </div>
                            <div className="info-value">{data?.rejected?.detail?.name || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Father's Name </div>
                            <div className="info-value">{data?.rejected?.detail?.father_or_husband_name || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Gender </div>
                            <div className="info-value">{data?.rejected?.detail?.gender || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Date of Birth </div>
                            <div className="info-value">{formatDob(data?.rejected?.detail?.dob) || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Blood Group </div>
                            <div className="info-value">{data?.rejected?.detail?.blood_group || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> RTO </div>
                            <div className="info-value">{data?.rejected?.detail?.ola_name || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> License Issuing State</div>
                            <div className="info-value">{data?.rejected?.detail?.state || "-"}</div>
                        </div>
                    </div>
                </div>
                <div className="mb-2">
                    <h4 className="section-title mb-4">Class of Vehicles</h4>
                    <div className="row">
                        {data?.rejected?.detail?.vehicle_classes?.map((item, index) => (
                            <div className="col-md-6 mb-4" key={index}>
                                <div className="vehicle-card p-4 h-100">
                                    <div className="d-flex justify-content-between">
                                        <h5 className="fw-bold">{item}</h5>
                                        <span className="vehicle-icon">
                                            {item === "LMV" ? <LiaCarSideSolid /> : <MdOutlineDirectionsBike />}
                                        </span>
                                    </div>

                                    <hr />

                                    <p>
                                        <strong>Issue Date:</strong>{" "}
                                        {data?.rejected?.detail?.doi}
                                    </p>
                                    <p>
                                        <strong>Expiry Date:</strong>{" "}
                                        {data?.rejected?.detail?.doe}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mb-2">
                    <h4 className="section-title mb-4">Addresses</h4>
                    <div className="address-display mb-4" >
                        <h6>Permanent Address</h6>
                        {
                            data?.rejected?.detail?.permanent_address ?
                                <p className="m-0">{data?.rejected?.detail?.permanent_address}</p>
                                :
                                <p className="m-0 text-muted">No address details available</p>
                        }
                    </div>
                    <div className="address-display mb-4" >
                        <h6>Temporary Address</h6>
                        {
                            data?.rejected?.detail?.temporary_address ?
                                <p className="m-0">{data?.rejected?.detail?.temporary_address}</p>
                                :
                                <p className="m-0 text-muted">No address details available</p>
                        }
                    </div>
                </div>
                {
                    data?.rejected?.photo?.length ?
                        <div className="my-3">
                            <div className="row">
                                {
                                    data?.rejected?.photo?.map((ele, i) => {
                                        return (
                                            <div className="col-md-6" key={ele}>
                                                <div className="aadhaar-images">
                                                    <img src={ele} alt="Aadhaar" />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : ""
                }
            </DetailCard>
        </React.Fragment>
    )
}

export default DL